import React, { useState, useEffect } from 'react';
import usePortalUser from '../../auth/usePortalUser';
import { getCurrentSession } from '../../auth/cognito';
import ChangePasswordForm from '../../components/ChangePasswordForm';
import EmailClient from '../../components/EmailClient';
import './Portal.css';
import './OwnerPortal.css';

const API = process.env.REACT_APP_API_URL || 'https://api.stratosstandard.com';

const EMPTY_STATS   = { sessionsToday: 0, sessionsThisWeek: 0, revenueThisWeek: 0, activeConsultants: 0, openS1Issues: 0 };
const EMPTY_REVENUE = { thisWeek: 0, thisMonth: 0, allTime: 0, transactions: [] };

/* ─── Inline SVG icons ─── */
const GridIcon     = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>;
const BellIcon     = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>;
const ListIcon     = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>;
const UsersIcon    = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const ChartIcon    = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>;
const CalendarIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>;
const AlertIcon    = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>;
const SignOutIcon  = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>;
const DollarIcon   = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>;
const LockIcon     = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>;
const MailIcon     = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 8l10 6 10-6"/></svg>;
const RefreshIcon  = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>;
const TagIcon      = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>;
const BookIcon     = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>;
const StarIcon     = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;

/* ─── Shared micro-components ─── */

function StatCard({ icon, iconClass, value, label }) {
  return (
    <div className="portal-stat-card">
      <div className={`psc-icon ${iconClass}`}>{icon}</div>
      <div className="psc-value">{value}</div>
      <div className="psc-label">{label}</div>
    </div>
  );
}

function PortalPanel({ title, children }) {
  return (
    <div className="portal-panel">
      <div className="portal-panel-header">
        <span className="portal-panel-title">{title}</span>
      </div>
      {children}
    </div>
  );
}

function PortalEmptyState({ title, message, icon }) {
  return (
    <div className="portal-empty-state">
      {icon && <div className="pes-icon">{icon}</div>}
      <p className="pes-title">{title}</p>
      {message && <p className="pes-text">{message}</p>}
    </div>
  );
}

function StatusPill({ status }) {
  const label = status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ');
  return <span className={`pill pill-${status.replace(/_/g, '-')}`}>{label}</span>;
}

/* ─── Dashboard view ─── */
function DashboardView({ stats, alerts, todaySessions, onGoToAlerts }) {
  return (
    <>
      <div className="portal-stat-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))' }}>
        <StatCard icon={<CalendarIcon />} iconClass="psc-icon-aero"  value={stats.sessionsToday}                         label="Sessions Today"      />
        <StatCard icon={<CalendarIcon />} iconClass="psc-icon-sky"   value={stats.sessionsThisWeek}                      label="Sessions This Week"  />
        <StatCard icon={<DollarIcon />}   iconClass="psc-icon-green" value={`$${stats.revenueThisWeek.toLocaleString()}`} label="Revenue This Week"  />
        <StatCard icon={<UsersIcon />}    iconClass="psc-icon-navy"  value={stats.activeConsultants}                     label="Active Consultants"  />
        <StatCard
          icon={<AlertIcon />}
          iconClass={stats.openS1Issues > 0 ? 'psc-icon-red' : 'psc-icon-navy'}
          value={stats.openS1Issues}
          label="Open S1 Issues"
        />
      </div>

      {alerts.length > 0 && (
        <div className="alert-strip" role="alert">
          <AlertIcon />
          <span>
            <strong>{alerts.length} active S1 issue{alerts.length !== 1 ? 's' : ''}</strong> — immediate attention required.
          </span>
          <button className="alert-strip-link" onClick={onGoToAlerts}>View Alerts →</button>
        </div>
      )}

      <PortalPanel title="Today's Schedule">
        {todaySessions.length === 0
          ? <PortalEmptyState icon={<CalendarIcon />} title="No sessions scheduled today" />
          : (
            <div className="portal-table-wrap">
              <table className="portal-table">
                <thead>
                  <tr><th>Time</th><th>Child</th><th>Service</th><th>Consultant</th><th>Status</th></tr>
                </thead>
                <tbody>
                  {todaySessions.map(s => (
                    <tr key={s.id}>
                      <td className="td-primary">{s.time}</td>
                      <td>{s.child}</td>
                      <td>{s.service}</td>
                      <td>{s.consultant}</td>
                      <td><StatusPill status={s.status} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        }
      </PortalPanel>
    </>
  );
}

/* ─── Alerts view ─── */
function AlertsView({ alerts }) {
  return (
    <>
      <div style={{ marginBottom: '20px' }}>
        <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.1rem', color: 'var(--midnight)' }}>
          Severity 1 Issues
        </h2>
        <p style={{ fontSize: '0.875rem', color: 'var(--gray-400)', marginTop: '4px' }}>
          Critical issues requiring immediate attention.
        </p>
      </div>

      {alerts.length === 0
        ? (
          <div className="portal-panel">
            <PortalEmptyState
              icon={<AlertIcon />}
              title="No active S1 issues"
              message="All clear — no severity 1 issues at this time."
            />
          </div>
        )
        : (
          <div className="alerts-list">
            {alerts.map(a => (
              <div key={a.id} className="alert-card" role="alert">
                <p className="alert-card-title"><AlertIcon /> {a.title}</p>
                <p className="alert-card-detail">{a.detail}</p>
                <p className="alert-card-time">{new Date(a.createdAt).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}</p>
              </div>
            ))}
          </div>
        )
      }

      <div className="ticketing-placeholder">
        <p className="tp-label">Future: Ticketing System Integration</p>
        <p className="tp-text">
          Once a ticketing system (e.g. PagerDuty, Linear, Jira) is connected, S1 alerts will
          auto-populate from that source and support acknowledgment, assignment, and resolution tracking.
        </p>
      </div>
    </>
  );
}

const REFUNDABLE_STATUSES = new Set(['pending_consultant', 'assigned', 'confirmed', 'payment_failed']);

/* ─── All bookings view ─── */
function BookingsView({ bookings, onRefund }) {
  const [filter,      setFilter]      = useState('all');
  const [confirmId,   setConfirmId]   = useState(null);
  const [refunding,   setRefunding]   = useState(false);
  const [refundError, setRefundError] = useState(null);

  const filters = ['all', 'confirmed', 'pending_consultant', 'assigned', 'cancelled', 'refunded'];
  const filtered = filter === 'all' ? bookings : bookings.filter(b => b.status === filter);

  async function handleRefund(bookingId) {
    setRefunding(true);
    setRefundError(null);
    try {
      await onRefund(bookingId);
      setConfirmId(null);
    } catch (err) {
      setRefundError(err.message);
    } finally {
      setRefunding(false);
    }
  }

  return (
    <>
      <div className="filter-pills">
        {filters.map(f => (
          <button
            key={f}
            className={`filter-pill ${filter === f ? 'active' : ''}`}
            onClick={() => setFilter(f)}
          >
            {f === 'all' ? 'All' : f.charAt(0).toUpperCase() + f.slice(1).replace(/_/g, ' ')}
            {f !== 'all' && (
              <span className="filter-pill-count">
                {bookings.filter(b => b.status === f).length}
              </span>
            )}
          </button>
        ))}
      </div>

      {refundError && (
        <div className="alert-strip" role="alert" style={{ marginBottom: 12 }}>
          <AlertIcon />
          <span>{refundError}</span>
          <button className="alert-strip-link" onClick={() => setRefundError(null)}>Dismiss</button>
        </div>
      )}

      <div className="portal-panel">
        {filtered.length === 0
          ? <PortalEmptyState icon={<ListIcon />} title="No bookings match this filter" />
          : (
            <div className="portal-table-wrap">
              <table className="portal-table">
                <thead>
                  <tr>
                    <th>Date</th><th>Child</th><th>Service</th><th>Consultant</th>
                    <th>Amount</th><th>Status</th><th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map(b => (
                    <tr key={b.id}>
                      <td className="td-primary">{b.date}</td>
                      <td>{b.child}</td>
                      <td>{b.service}</td>
                      <td>{b.consultant}</td>
                      <td>${b.amount}</td>
                      <td><StatusPill status={b.status} /></td>
                      <td>
                        {confirmId === b.id ? (
                          <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center', fontSize: 13 }}>
                            <span style={{ color: '#92400e' }}>Refund ${b.amount}?</span>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleRefund(b.id)}
                              disabled={refunding}
                            >
                              {refunding ? '…' : 'Confirm'}
                            </button>
                            <button
                              className="btn btn-sm"
                              onClick={() => { setConfirmId(null); setRefundError(null); }}
                              disabled={refunding}
                            >
                              Cancel
                            </button>
                          </span>
                        ) : (
                          REFUNDABLE_STATUSES.has(b.status) && b.paymentIntentId ? (
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => { setConfirmId(b.id); setRefundError(null); }}
                            >
                              Refund
                            </button>
                          ) : null
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        }
      </div>
    </>
  );
}

/* ─── Consultants view ─── */
const TIER_OPTIONS = [
  { value: 'associate',    label: 'SKIES Associate',    rank: 1, scope: 'Foundational only' },
  { value: 'practitioner', label: 'SKIES Practitioner', rank: 2, scope: 'Foundational + Advanced' },
  { value: 'lead',         label: 'SKIES Lead',         rank: 3, scope: 'All tiers (incl. Mastery)' },
];

function tierLabel(value) {
  const opt = TIER_OPTIONS.find(t => t.value === value);
  return opt ? opt.label : 'Unassigned';
}

function TierBadge({ tier }) {
  if (!tier) return <span className="tier-badge tier-badge-none">Unassigned</span>;
  return <span className={`tier-badge tier-badge-${tier}`}>{tierLabel(tier)}</span>;
}

function ConsultantTierEditor({ consultant, onSave, busy, error }) {
  const [draft, setDraft] = useState(consultant.consultantTier || '');

  const isDirty = draft && draft !== consultant.consultantTier;
  const draftLabel = TIER_OPTIONS.find(t => t.value === draft)?.label;

  return (
    <div className="tier-editor">
      <select
        className="tier-select"
        value={draft}
        onChange={e => setDraft(e.target.value)}
        disabled={busy}
        aria-label={`Tier for ${consultant.name}`}
      >
        <option value="" disabled>Select tier…</option>
        {TIER_OPTIONS.map(t => (
          <option key={t.value} value={t.value}>{t.label} — {t.scope}</option>
        ))}
      </select>
      <button
        className="btn btn-sm btn-aero"
        disabled={!isDirty || busy}
        onClick={() => {
          const verb = consultant.consultantTier ? 'change' : 'set';
          const ok = window.confirm(
            `${verb === 'change' ? 'Change' : 'Set'} ${consultant.name}'s tier ` +
            `${consultant.consultantTier ? `from ${tierLabel(consultant.consultantTier)} ` : ''}` +
            `to ${draftLabel}?`
          );
          if (ok) onSave(draft);
        }}
      >
        {busy ? 'Saving…' : 'Apply'}
      </button>
      {error && <span className="tier-error">{error}</span>}
    </div>
  );
}

function AddConsultantForm({ onCreate }) {
  const [open,          setOpen]          = useState(false);
  const [name,          setName]          = useState('');
  const [localPart,     setLocalPart]     = useState('');
  // Personal email is used once to send the Cognito invitation (containing
  // the temp password) and is not stored on the platform — the field clears
  // on submit and is never displayed back to admin afterward.
  const [personalEmail, setPersonalEmail] = useState('');
  const [busy,          setBusy]          = useState(false);
  const [error,         setError]         = useState(null);

  function reset() {
    setName(''); setLocalPart(''); setPersonalEmail(''); setError(null); setBusy(false);
  }

  function sanitizeLocal(val) {
    return val.toLowerCase().replace(/[^a-z0-9._-]/g, '');
  }

  async function submit(e) {
    e.preventDefault();
    const trimmedName     = name.trim();
    const local           = localPart.trim();
    const trimmedPersonal = personalEmail.trim().toLowerCase();
    if (!trimmedName || !local) {
      setError('Name and Stratos email are required.');
      return;
    }
    if (!trimmedPersonal || !/^\S+@\S+\.\S+$/.test(trimmedPersonal)) {
      setError("Enter the consultant's personal email so they can receive the invitation.");
      return;
    }
    if (trimmedPersonal.endsWith('@stratosstandard.com')) {
      setError('Personal email cannot be a @stratosstandard.com address.');
      return;
    }
    const stratosEmail = `${local}@stratosstandard.com`;
    if (!window.confirm(`Add ${trimmedName} as a consultant?\n\nThis will create:\n• Portal login: ${stratosEmail}\n• Email mailbox: ${stratosEmail}\n\nAn invitation with the temporary password will be sent to ${trimmedPersonal}. The personal address is used once and not retained by the platform.`)) {
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await onCreate({ name: trimmedName, stratosEmail, personalEmail: trimmedPersonal });
      reset();
      setOpen(false);
    } catch (err) {
      setError(err.message || 'Could not add consultant');
    } finally {
      setBusy(false);
    }
  }

  if (!open) {
    return (
      <div className="consultant-actions-bar">
        <button className="btn btn-aero btn-sm" onClick={() => setOpen(true)}>
          + Add Consultant
        </button>
      </div>
    );
  }

  return (
    <form className="add-consultant-form" onSubmit={submit}>
      <div className="acf-fields">
        <div className="acf-row-two">
          <label className="acf-field">
            <span>Name</span>
            <input
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="Full name"
              disabled={busy}
              required
            />
          </label>
          <label className="acf-field">
            <span>Stratos Email</span>
            <div className="acf-email-row">
              <input
                type="text"
                value={localPart}
                onChange={e => setLocalPart(sanitizeLocal(e.target.value))}
                placeholder="firstname.lastname"
                disabled={busy}
                required
              />
              <span className="acf-email-suffix">@stratosstandard.com</span>
            </div>
          </label>
        </div>
        <label className="acf-field acf-field-personal">
          <span className="acf-field-personal-label">Personal email <span className="acf-field-required">— required to send the invitation</span></span>
          <input
            type="email"
            value={personalEmail}
            onChange={e => setPersonalEmail(e.target.value)}
            placeholder="consultant@gmail.com"
            disabled={busy}
            autoComplete="off"
            required
          />
          <span className="acf-helper">
            The temporary password is sent here. Not stored on the platform after the invitation goes out.
          </span>
        </label>
      </div>
      <div className="acf-actions">
        <button type="submit" className="btn btn-aero btn-sm" disabled={busy}>
          {busy ? 'Adding…' : 'Add Consultant'}
        </button>
        <button
          type="button"
          className="btn btn-ghost btn-sm"
          onClick={() => { reset(); setOpen(false); }}
          disabled={busy}
        >
          Cancel
        </button>
        {error && <span className="tier-error">{error}</span>}
      </div>
    </form>
  );
}

function ConsultantRowActions({ consultant, busy, onToggleStatus, onRemove }) {
  const isPaused  = consultant.status === 'paused';
  const toggleLabel = isPaused ? 'Resume' : 'Pause';

  return (
    <div className="consultant-row-actions">
      <button
        className={`btn btn-sm ${isPaused ? 'btn-aero' : 'btn-ghost'}`}
        disabled={busy}
        onClick={() => {
          const verb = isPaused ? 'resume' : 'pause';
          if (window.confirm(`Are you sure you want to ${verb} ${consultant.name}?`)) {
            onToggleStatus(isPaused ? 'active' : 'paused');
          }
        }}
      >
        {busy ? '…' : toggleLabel}
      </button>
      <button
        className="btn btn-sm btn-danger"
        disabled={busy}
        onClick={() => {
          if (window.confirm(
            `Remove ${consultant.name}? This permanently deletes the consultant record and cannot be undone.`
          )) {
            onRemove();
          }
        }}
      >
        Remove
      </button>
    </div>
  );
}

function ConsultantsView({ consultants, onUpdateTier, onCreate, onUpdateStatus, onRemove }) {
  // Local in-flight + per-row error state, keyed by consultant id, so saves
  // don't disable the whole table and errors only surface inline.
  const [savingId,    setSavingId]    = useState(null);
  const [actingId,    setActingId]    = useState(null);
  const [errorById,   setErrorById]   = useState({});
  const [actionError, setActionError] = useState({});

  const handleSave = async (consultant, newTier) => {
    setSavingId(consultant.id);
    setErrorById(prev => ({ ...prev, [consultant.id]: null }));
    try {
      await onUpdateTier(consultant.id, newTier);
    } catch (err) {
      setErrorById(prev => ({ ...prev, [consultant.id]: err.message || 'Update failed' }));
    } finally {
      setSavingId(null);
    }
  };

  const handleStatus = async (consultant, newStatus) => {
    setActingId(consultant.id);
    setActionError(prev => ({ ...prev, [consultant.id]: null }));
    try {
      await onUpdateStatus(consultant.id, newStatus);
    } catch (err) {
      setActionError(prev => ({ ...prev, [consultant.id]: err.message || 'Update failed' }));
    } finally {
      setActingId(null);
    }
  };

  const handleRemove = async (consultant) => {
    setActingId(consultant.id);
    setActionError(prev => ({ ...prev, [consultant.id]: null }));
    try {
      await onRemove(consultant.id);
    } catch (err) {
      setActionError(prev => ({ ...prev, [consultant.id]: err.message || 'Remove failed' }));
      setActingId(null);
    }
  };

  return (
    <PortalPanel title="All Consultants">
      <AddConsultantForm onCreate={onCreate} />
      {consultants.length === 0
        ? <PortalEmptyState icon={<UsersIcon />} title="No consultants found" message="Use “Add Consultant” to create the first record." />
        : (
          <div className="portal-table-wrap">
            <table className="portal-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Tier</th>
                  <th>Sessions This Week</th>
                  <th>Manage Tier</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {consultants.map(c => (
                  <tr key={c.id}>
                    <td className="td-primary">
                      {c.name}
                      {c.tierUpdatedAt && (
                        <div className="tier-audit-line">
                          {c.previousTier ? `${tierLabel(c.previousTier)} → ${tierLabel(c.consultantTier)}` : `Set to ${tierLabel(c.consultantTier)}`}
                          {' · '}
                          {new Date(c.tierUpdatedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                          {c.tierUpdatedBy && ` by ${c.tierUpdatedBy}`}
                        </div>
                      )}
                    </td>
                    <td><StatusPill status={c.status} /></td>
                    <td><TierBadge tier={c.consultantTier} /></td>
                    <td>{c.sessionsThisWeek}</td>
                    <td>
                      <ConsultantTierEditor
                        consultant={c}
                        onSave={tier => handleSave(c, tier)}
                        busy={savingId === c.id}
                        error={errorById[c.id]}
                      />
                    </td>
                    <td>
                      <ConsultantRowActions
                        consultant={c}
                        busy={actingId === c.id}
                        onToggleStatus={status => handleStatus(c, status)}
                        onRemove={() => handleRemove(c)}
                      />
                      {actionError[c.id] && (
                        <div className="tier-error" style={{ marginTop: 6 }}>
                          {actionError[c.id]}
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      }
    </PortalPanel>
  );
}

/* ─── Discounts view ─── */
function discountLabel(type, value) {
  return type === 'percent' ? `${value}% off` : `$${value} off`;
}

function AddDiscountForm({ onCreate }) {
  const [open,        setOpen]        = useState(false);
  const [code,        setCode]        = useState('');
  const [type,        setType]        = useState('percent');
  const [value,       setValue]       = useState('');
  const [limit,       setLimit]       = useState('');
  const [description, setDescription] = useState('');
  const [busy,        setBusy]        = useState(false);
  const [error,       setError]       = useState(null);

  function reset() {
    setCode(''); setType('percent'); setValue(''); setLimit(''); setDescription(''); setError(null); setBusy(false);
  }

  async function submit(e) {
    e.preventDefault();
    const trimmedCode = code.trim().toUpperCase();
    const numValue    = Number(value);
    if (!/^[A-Z0-9][A-Z0-9_-]{2,31}$/.test(trimmedCode)) {
      setError('Code must be 3–32 characters: letters, numbers, hyphen or underscore.');
      return;
    }
    if (!Number.isFinite(numValue) || numValue <= 0 || (type === 'percent' && numValue > 100)) {
      setError(type === 'percent' ? 'Percent must be between 1 and 100.' : 'Amount must be greater than 0.');
      return;
    }
    // Blank limit = unlimited; a value must be a whole number ≥ 1.
    let usageLimit = null;
    if (limit.trim() !== '') {
      const numLimit = Number(limit);
      if (!Number.isInteger(numLimit) || numLimit < 1) {
        setError('Usage limit must be a whole number of uses (1 or more), or left blank for unlimited.');
        return;
      }
      usageLimit = numLimit;
    }
    setBusy(true);
    setError(null);
    try {
      await onCreate({ code: trimmedCode, discountType: type, discountValue: numValue, usageLimit, description: description.trim() });
      reset();
      setOpen(false);
    } catch (err) {
      setError(err.message || 'Could not create code');
      setBusy(false);
    }
  }

  if (!open) {
    return (
      <div className="consultant-actions-bar">
        <button className="btn btn-aero btn-sm" onClick={() => setOpen(true)}>+ Add Discount Code</button>
      </div>
    );
  }

  return (
    <form className="add-consultant-form" onSubmit={submit}>
      <div className="acf-fields">
        <div className="acf-row-two">
          <label className="acf-field">
            <span>Code</span>
            <input
              type="text"
              value={code}
              onChange={e => setCode(e.target.value.toUpperCase())}
              placeholder="WELCOME20"
              disabled={busy}
              required
            />
          </label>
          <label className="acf-field">
            <span>Discount</span>
            <div className="discount-edit-row">
              <select className="tier-select" value={type} onChange={e => setType(e.target.value)} disabled={busy}>
                <option value="percent">Percent %</option>
                <option value="fixed">Fixed $</option>
              </select>
              <input
                type="number"
                min="1"
                className="discount-value-input"
                value={value}
                onChange={e => setValue(e.target.value)}
                placeholder={type === 'percent' ? '20' : '15'}
                disabled={busy}
                required
              />
            </div>
          </label>
        </div>
        <div className="acf-row-two">
          <label className="acf-field">
            <span>Usage limit <span className="acf-field-required">— optional, blank = unlimited</span></span>
            <input
              type="number"
              min="1"
              step="1"
              value={limit}
              onChange={e => setLimit(e.target.value)}
              placeholder="e.g. 10 uses"
              disabled={busy}
            />
          </label>
          <label className="acf-field">
            <span>Description <span className="acf-field-required">— optional internal note</span></span>
            <input
              type="text"
              value={description}
              onChange={e => setDescription(e.target.value)}
              placeholder="Spring 2026 promo"
              disabled={busy}
            />
          </label>
        </div>
      </div>
      <div className="acf-actions">
        <button type="submit" className="btn btn-aero btn-sm" disabled={busy}>
          {busy ? 'Adding…' : 'Add Code'}
        </button>
        <button type="button" className="btn btn-ghost btn-sm" onClick={() => { reset(); setOpen(false); }} disabled={busy}>
          Cancel
        </button>
        {error && <span className="tier-error">{error}</span>}
      </div>
    </form>
  );
}

function DiscountRow({ d, onUpdate, onDelete }) {
  const [editing, setEditing] = useState(false);
  const [type,    setType]    = useState(d.discountType);
  const [value,   setValue]   = useState(String(d.discountValue));
  const [limit,   setLimit]   = useState(d.usageLimit != null ? String(d.usageLimit) : '');
  const [busy,    setBusy]    = useState(false);
  const [error,   setError]   = useState(null);

  function cancelEdit() {
    setEditing(false);
    setType(d.discountType);
    setValue(String(d.discountValue));
    setLimit(d.usageLimit != null ? String(d.usageLimit) : '');
    setError(null);
  }

  async function save() {
    const numValue = Number(value);
    if (!Number.isFinite(numValue) || numValue <= 0 || (type === 'percent' && numValue > 100)) {
      setError(type === 'percent' ? 'Percent must be 1–100.' : 'Amount must be greater than 0.');
      return;
    }
    // Blank limit clears the cap (unlimited); send null so the API removes it.
    let usageLimit = null;
    if (limit.trim() !== '') {
      const numLimit = Number(limit);
      if (!Number.isInteger(numLimit) || numLimit < 1) {
        setError('Limit must be a whole number ≥ 1, or blank for unlimited.');
        return;
      }
      usageLimit = numLimit;
    }
    setBusy(true);
    setError(null);
    try {
      await onUpdate(d.code, { discountType: type, discountValue: numValue, usageLimit });
      setEditing(false);
    } catch (err) {
      setError(err.message || 'Update failed');
    } finally {
      setBusy(false);
    }
  }

  async function toggleActive() {
    setBusy(true);
    setError(null);
    try {
      await onUpdate(d.code, { active: !d.active });
    } catch (err) {
      setError(err.message || 'Update failed');
    } finally {
      setBusy(false);
    }
  }

  async function remove() {
    if (!window.confirm(
      `Delete code ${d.code}? It can no longer be applied at checkout. Past bookings keep the discount they already received.`
    )) return;
    setBusy(true);
    setError(null);
    try {
      await onDelete(d.code);
    } catch (err) {
      setError(err.message || 'Delete failed');
      setBusy(false);
    }
  }

  return (
    <tr>
      <td className="td-primary">
        {d.code}
        {d.description && <div className="tier-audit-line">{d.description}</div>}
      </td>
      <td>
        {editing ? (
          <span className="discount-edit-row">
            <select className="tier-select" value={type} onChange={e => setType(e.target.value)} disabled={busy}>
              <option value="percent">%</option>
              <option value="fixed">$</option>
            </select>
            <input
              type="number"
              min="1"
              className="discount-value-input"
              value={value}
              onChange={e => setValue(e.target.value)}
              disabled={busy}
              aria-label={`Discount value for ${d.code}`}
            />
          </span>
        ) : discountLabel(d.discountType, d.discountValue)}
      </td>
      <td><StatusPill status={d.active ? 'active' : 'paused'} /></td>
      <td>{d.usageCount}</td>
      <td>
        {editing ? (
          <input
            type="number"
            min="1"
            step="1"
            className="discount-value-input"
            value={limit}
            onChange={e => setLimit(e.target.value)}
            placeholder="∞"
            disabled={busy}
            aria-label={`Usage limit for ${d.code}`}
          />
        ) : d.usageLimit != null ? (
          <>
            {d.usageLimit}
            <div className={`tier-audit-line${d.usesRemaining === 0 ? ' discount-exhausted' : ''}`}>
              {d.usesRemaining === 0 ? 'none left' : `${d.usesRemaining} left`}
            </div>
          </>
        ) : (
          <span className="discount-unlimited">Unlimited</span>
        )}
      </td>
      <td>${d.totalDiscounted}</td>
      <td>
        <div className="consultant-row-actions">
          {editing ? (
            <>
              <button className="btn btn-sm btn-aero" disabled={busy} onClick={save}>{busy ? '…' : 'Save'}</button>
              <button className="btn btn-sm btn-ghost" disabled={busy} onClick={cancelEdit}>Cancel</button>
            </>
          ) : (
            <>
              <button className="btn btn-sm btn-aero" disabled={busy} onClick={() => setEditing(true)}>Edit</button>
              <button
                className={`btn btn-sm ${d.active ? 'btn-ghost' : 'btn-aero'}`}
                disabled={busy}
                onClick={toggleActive}
              >
                {d.active ? 'Disable' : 'Enable'}
              </button>
              <button className="btn btn-sm btn-danger" disabled={busy} onClick={remove}>Delete</button>
            </>
          )}
        </div>
        {error && <div className="tier-error" style={{ marginTop: 6 }}>{error}</div>}
      </td>
    </tr>
  );
}

function DiscountsView({ discounts, onCreate, onUpdate, onDelete }) {
  const codes       = discounts.codes || [];
  const redemptions = discounts.redemptions || [];

  return (
    <>
      <PortalPanel title="Discount Codes">
        <AddDiscountForm onCreate={onCreate} />
        {codes.length === 0
          ? <PortalEmptyState icon={<TagIcon />} title="No discount codes yet" message="Use “Add Discount Code” to create your first one." />
          : (
            <div className="portal-table-wrap">
              <table className="portal-table">
                <thead>
                  <tr><th>Code</th><th>Discount</th><th>Status</th><th>Uses</th><th>Limit</th><th>Total Off</th><th>Actions</th></tr>
                </thead>
                <tbody>
                  {codes.map(d => <DiscountRow key={d.code} d={d} onUpdate={onUpdate} onDelete={onDelete} />)}
                </tbody>
              </table>
            </div>
          )
        }
      </PortalPanel>

      <PortalPanel title="Discount Usage Log">
        {redemptions.length === 0
          ? <PortalEmptyState icon={<TagIcon />} title="No code redemptions yet" message="Successful checkouts that used a code will appear here." />
          : (
            <div className="portal-table-wrap">
              <table className="portal-table">
                <thead>
                  <tr><th>Date</th><th>Code</th><th>Parent</th><th>Original</th><th>Discount</th><th>Paid</th></tr>
                </thead>
                <tbody>
                  {redemptions.map(r => (
                    <tr key={r.bookingId}>
                      <td className="td-primary">{r.date}</td>
                      <td>{r.code}</td>
                      <td>{r.parent}</td>
                      <td>{r.originalAmount != null ? `$${r.originalAmount}` : '—'}</td>
                      <td style={{ color: '#15803d', fontWeight: 600 }}>−${r.discountAmount}</td>
                      <td>${r.finalAmount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        }
      </PortalPanel>
    </>
  );
}

/* ─── Blog view ─── */
function PostForm({ initial, onSubmit, onCancel }) {
  const isEdit = !!initial;
  const [title,    setTitle]    = useState(initial?.title    || '');
  const [slug,     setSlug]     = useState(initial?.slug     || '');
  const [tag,      setTag]      = useState(initial?.tag      || '');
  const [date,     setDate]     = useState(initial?.date     || '');
  const [readTime, setReadTime] = useState(initial?.readTime || '');
  const [excerpt,  setExcerpt]  = useState(initial?.excerpt  || '');
  const [content,  setContent]  = useState(initial?.content  || '');
  const [featured, setFeatured] = useState(!!initial?.featured);
  const [status,   setStatus]   = useState(initial?.status   || 'draft');
  const [busy,     setBusy]     = useState(false);
  const [error,    setError]    = useState(null);

  async function submit(e) {
    e.preventDefault();
    if (!title.trim()) { setError('A title is required.'); return; }
    setBusy(true);
    setError(null);
    const payload = { title: title.trim(), tag, date, readTime, excerpt, content, featured, status };
    if (!isEdit) payload.slug = slug.trim() || title.trim();
    try {
      await onSubmit(payload);
    } catch (err) {
      setError(err.message || 'Could not save the post');
      setBusy(false);
    }
  }

  return (
    <form className="add-consultant-form" onSubmit={submit}>
      <div className="acf-fields">
        <label className="acf-field">
          <span>Title</span>
          <input type="text" value={title} onChange={e => setTitle(e.target.value)} placeholder="What Early Achievement Really Means" disabled={busy} required />
        </label>
        <div className="acf-row-two">
          <label className="acf-field">
            <span>Slug {isEdit ? <span className="acf-field-required">— fixed once created</span> : <span className="acf-field-required">— optional, defaults from title</span>}</span>
            <input type="text" value={slug} onChange={e => setSlug(e.target.value)} placeholder="early-achievement" disabled={busy || isEdit} />
          </label>
          <label className="acf-field">
            <span>Tag</span>
            <input type="text" value={tag} onChange={e => setTag(e.target.value)} placeholder="Development" disabled={busy} />
          </label>
        </div>
        <div className="acf-row-two">
          <label className="acf-field">
            <span>Date label</span>
            <input type="text" value={date} onChange={e => setDate(e.target.value)} placeholder="March 10, 2026" disabled={busy} />
          </label>
          <label className="acf-field">
            <span>Read time</span>
            <input type="text" value={readTime} onChange={e => setReadTime(e.target.value)} placeholder="5 min read" disabled={busy} />
          </label>
        </div>
        <label className="acf-field">
          <span>Excerpt <span className="acf-field-required">— short teaser shown on cards</span></span>
          <textarea value={excerpt} onChange={e => setExcerpt(e.target.value)} rows={2} placeholder="One or two sentences summarizing the post." disabled={busy} />
        </label>
        <label className="acf-field">
          <span>Body <span className="acf-field-required">— use **bold**, *italic*, and a **Heading** on its own line</span></span>
          <textarea value={content} onChange={e => setContent(e.target.value)} rows={14} placeholder={'Opening paragraph…\n\n**A Heading**\n\nMore text with **bold** and *italic*.'} disabled={busy} style={{ fontFamily: 'monospace', lineHeight: 1.6 }} />
        </label>
        <div className="acf-row-two">
          <label className="acf-field">
            <span>Status</span>
            <select className="tier-select" value={status} onChange={e => setStatus(e.target.value)} disabled={busy}>
              <option value="draft">Draft (hidden)</option>
              <option value="published">Published (live)</option>
            </select>
          </label>
          <label className="acf-field" style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
            <input type="checkbox" checked={featured} onChange={e => setFeatured(e.target.checked)} disabled={busy} />
            <span style={{ margin: 0 }}>Feature this post</span>
          </label>
        </div>
      </div>
      <div className="acf-actions">
        <button type="submit" className="btn btn-aero btn-sm" disabled={busy}>{busy ? 'Saving…' : (isEdit ? 'Save Changes' : 'Create Post')}</button>
        <button type="button" className="btn btn-ghost btn-sm" onClick={onCancel} disabled={busy}>Cancel</button>
        {error && <span className="tier-error">{error}</span>}
      </div>
    </form>
  );
}

function PostRow({ p, onEdit, onUpdate, onDelete }) {
  const [busy,  setBusy]  = useState(false);
  const [error, setError] = useState(null);

  async function toggleStatus() {
    setBusy(true); setError(null);
    try {
      await onUpdate(p.slug, { status: p.status === 'published' ? 'draft' : 'published' });
    } catch (err) {
      setError(err.message || 'Update failed');
    } finally {
      setBusy(false);
    }
  }

  async function remove() {
    if (!window.confirm(`Delete "${p.title}"? This permanently removes the post.`)) return;
    setBusy(true); setError(null);
    try {
      await onDelete(p.slug);
    } catch (err) {
      setError(err.message || 'Delete failed');
      setBusy(false);
    }
  }

  return (
    <tr>
      <td className="td-primary">
        {p.title}
        {p.featured && <span className="pill pill-active" style={{ marginLeft: 8 }}>Featured</span>}
        <div className="tier-audit-line">/blog/{p.slug}</div>
      </td>
      <td>{p.tag || '—'}</td>
      <td><StatusPill status={p.status === 'published' ? 'active' : 'paused'} /></td>
      <td>
        <div className="consultant-row-actions">
          <button className="btn btn-sm btn-aero" disabled={busy} onClick={() => onEdit(p.slug)}>Edit</button>
          <button className={`btn btn-sm ${p.status === 'published' ? 'btn-ghost' : 'btn-aero'}`} disabled={busy} onClick={toggleStatus}>
            {p.status === 'published' ? 'Unpublish' : 'Publish'}
          </button>
          <button className="btn btn-sm btn-danger" disabled={busy} onClick={remove}>Delete</button>
        </div>
        {error && <div className="tier-error" style={{ marginTop: 6 }}>{error}</div>}
      </td>
    </tr>
  );
}

function BlogView({ posts, onCreate, onUpdate, onDelete }) {
  const [mode, setMode] = useState(null); // null | 'add' | <slug being edited>
  const editing = posts.find(p => p.slug === mode);

  if (mode === 'add') {
    return (
      <PortalPanel title="New Post">
        <PostForm onSubmit={async (payload) => { await onCreate(payload); setMode(null); }} onCancel={() => setMode(null)} />
      </PortalPanel>
    );
  }
  if (editing) {
    return (
      <PortalPanel title={`Edit: ${editing.title}`}>
        <PostForm initial={editing} onSubmit={async (payload) => { await onUpdate(editing.slug, payload); setMode(null); }} onCancel={() => setMode(null)} />
      </PortalPanel>
    );
  }

  return (
    <PortalPanel title="Blog Posts">
      <div className="consultant-actions-bar">
        <button className="btn btn-aero btn-sm" onClick={() => setMode('add')}>+ New Post</button>
      </div>
      {posts.length === 0
        ? <PortalEmptyState icon={<BookIcon />} title="No posts yet" message="Use “New Post” to write your first article." />
        : (
          <div className="portal-table-wrap">
            <table className="portal-table">
              <thead>
                <tr><th>Title</th><th>Tag</th><th>Status</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {posts.map(p => <PostRow key={p.slug} p={p} onEdit={setMode} onUpdate={onUpdate} onDelete={onDelete} />)}
              </tbody>
            </table>
          </div>
        )
      }
    </PortalPanel>
  );
}

/* ─── Reviews view ─── */
function ReviewRow({ r, onUpdate, onDelete }) {
  const [editing, setEditing] = useState(false);
  const [name,  setName]  = useState(r.parentName);
  const [quote, setQuote] = useState(r.quote);
  const [busy,  setBusy]  = useState(false);
  const [error, setError] = useState(null);

  function cancelEdit() {
    setEditing(false);
    setName(r.parentName);
    setQuote(r.quote);
    setError(null);
  }

  async function run(fn) {
    setBusy(true); setError(null);
    try { await fn(); }
    catch (err) { setError(err.message || 'Action failed'); }
    finally { setBusy(false); }
  }

  async function save() {
    if (!quote.trim()) { setError('Review text is required.'); return; }
    setBusy(true); setError(null);
    try {
      await onUpdate(r.reviewId, { parentName: name.trim(), quote: quote.trim() });
      setEditing(false);
    } catch (err) {
      setError(err.message || 'Update failed');
    } finally {
      setBusy(false);
    }
  }

  async function remove() {
    if (!window.confirm(`Delete this review from ${r.parentName}? This cannot be undone.`)) return;
    await run(() => onDelete(r.reviewId));
  }

  return (
    <tr>
      <td className="td-primary" style={{ maxWidth: 420 }}>
        {editing ? (
          <>
            <input type="text" value={name} onChange={e => setName(e.target.value)} disabled={busy} aria-label="Reviewer name" style={{ marginBottom: 6, width: '100%' }} />
            <textarea value={quote} onChange={e => setQuote(e.target.value)} rows={3} disabled={busy} aria-label="Review text" style={{ width: '100%' }} />
          </>
        ) : (
          <>
            “{r.quote}”
            <div className="tier-audit-line">
              {r.parentName}{r.childFirstName ? ` · child ${r.childFirstName}${r.childAge ? `, ${r.childAge}` : ''}` : ''}
            </div>
          </>
        )}
      </td>
      <td style={{ color: '#d4a017', whiteSpace: 'nowrap' }}>{'★'.repeat(Math.max(1, Math.min(5, r.rating || 5)))}</td>
      <td><StatusPill status={r.status} /></td>
      <td>
        <div className="consultant-row-actions">
          {editing ? (
            <>
              <button className="btn btn-sm btn-aero" disabled={busy} onClick={save}>{busy ? '…' : 'Save'}</button>
              <button className="btn btn-sm btn-ghost" disabled={busy} onClick={cancelEdit}>Cancel</button>
            </>
          ) : (
            <>
              {r.status !== 'approved' && (
                <button className="btn btn-sm btn-aero" disabled={busy} onClick={() => run(() => onUpdate(r.reviewId, { status: 'approved' }))}>Approve</button>
              )}
              {r.status !== 'hidden' && (
                <button className="btn btn-sm btn-ghost" disabled={busy} onClick={() => run(() => onUpdate(r.reviewId, { status: 'hidden' }))}>Hide</button>
              )}
              <button className="btn btn-sm btn-aero" disabled={busy} onClick={() => setEditing(true)}>Edit</button>
              <button className="btn btn-sm btn-danger" disabled={busy} onClick={remove}>Delete</button>
            </>
          )}
        </div>
        {error && <div className="tier-error" style={{ marginTop: 6 }}>{error}</div>}
      </td>
    </tr>
  );
}

function ReviewsView({ reviews, onUpdate, onDelete }) {
  const pending  = reviews.filter(r => r.status === 'pending');
  const others   = reviews.filter(r => r.status !== 'pending');

  return (
    <PortalPanel title="Parent Reviews">
      {reviews.length === 0
        ? <PortalEmptyState icon={<StarIcon />} title="No reviews yet" message="Submissions from the public reviews page will appear here for approval." />
        : (
          <div className="portal-table-wrap">
            <table className="portal-table">
              <thead>
                <tr><th>Review</th><th>Rating</th><th>Status</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {[...pending, ...others].map(r => <ReviewRow key={r.reviewId} r={r} onUpdate={onUpdate} onDelete={onDelete} />)}
              </tbody>
            </table>
          </div>
        )
      }
    </PortalPanel>
  );
}

/* ─── Revenue view ─── */
function RevenueView({ revenue }) {
  return (
    <>
      <div className="revenue-summary">
        <div className="portal-stat-card">
          <div className="psc-icon psc-icon-green"><DollarIcon /></div>
          <div className="psc-value">${revenue.thisWeek.toLocaleString()}</div>
          <div className="psc-label">This Week</div>
        </div>
        <div className="portal-stat-card">
          <div className="psc-icon psc-icon-aero"><DollarIcon /></div>
          <div className="psc-value">${revenue.thisMonth.toLocaleString()}</div>
          <div className="psc-label">This Month</div>
        </div>
        <div className="portal-stat-card">
          <div className="psc-icon psc-icon-gold"><DollarIcon /></div>
          <div className="psc-value">${revenue.allTime.toLocaleString()}</div>
          <div className="psc-label">All Time</div>
        </div>
      </div>

      <PortalPanel title="Recent Transactions">
        {revenue.transactions.length === 0
          ? <PortalEmptyState icon={<DollarIcon />} title="No transactions yet" />
          : (
            <div className="portal-table-wrap">
              <table className="portal-table">
                <thead>
                  <tr><th>Date</th><th>Parent</th><th>Service</th><th>Amount</th><th>Status</th></tr>
                </thead>
                <tbody>
                  {revenue.transactions.map(tx => (
                    <tr key={tx.id}>
                      <td className="td-primary">{tx.date}</td>
                      <td>{tx.parent}</td>
                      <td>{tx.service}</td>
                      <td style={{ fontWeight: 600, color: tx.status === 'refunded' ? '#b91c1c' : 'var(--midnight)' }}>
                        {tx.status === 'refunded' ? '−' : '+'}${tx.amount}
                      </td>
                      <td><StatusPill status={tx.status} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        }
      </PortalPanel>
    </>
  );
}

/* ─── Main component ─── */
export default function OwnerPortal() {
  const user = usePortalUser();
  const [activeView, setActiveView] = useState('dashboard');

  const [loading,     setLoading]     = useState(true);
  const [fetchError,  setFetchError]  = useState(null);
  const [stats,       setStats]       = useState(EMPTY_STATS);
  const [todaySessions, setToday]     = useState([]);
  const [alerts,      setAlerts]      = useState([]);
  const [bookings,    setBookings]    = useState([]);
  const [consultants, setConsultants] = useState([]);
  const [revenue,     setRevenue]     = useState(EMPTY_REVENUE);
  const [discounts,   setDiscounts]   = useState({ codes: [], redemptions: [] });
  const [posts,       setPosts]       = useState([]);
  const [reviews,     setReviews]     = useState([]);

  useEffect(() => {
    let cancelled = false;

    async function loadAll() {
      const session = await getCurrentSession();
      if (!session?.idToken) { setLoading(false); return; }
      const headers = { Authorization: `Bearer ${session.idToken}` };

      try {
        const [sRes, bRes, cRes, rRes, dRes, pRes, vRes] = await Promise.all([
          fetch(`${API}/admin/stats`,       { headers }),
          fetch(`${API}/admin/bookings`,    { headers }),
          fetch(`${API}/admin/consultants`, { headers }),
          fetch(`${API}/admin/revenue`,     { headers }),
          fetch(`${API}/admin/discounts`,   { headers }),
          fetch(`${API}/admin/posts`,       { headers }),
          fetch(`${API}/admin/reviews`,     { headers }),
        ]);

        const [sData, bData, cData, rData, dData, pData, vData] = await Promise.all([
          sRes.ok ? sRes.json() : null,
          bRes.ok ? bRes.json() : null,
          cRes.ok ? cRes.json() : null,
          rRes.ok ? rRes.json() : null,
          dRes.ok ? dRes.json() : null,
          pRes.ok ? pRes.json() : null,
          vRes.ok ? vRes.json() : null,
        ]);

        if (cancelled) return;

        if (sData) { setStats(sData.stats); setToday(sData.todaySessions || []); setAlerts(sData.alerts || []); }
        if (bData) setBookings(bData.bookings || []);
        if (cData) setConsultants(cData.consultants || []);
        if (rData) setRevenue(rData);
        if (dData) setDiscounts({ codes: dData.codes || [], redemptions: dData.redemptions || [] });
        if (pData) setPosts(pData.posts || []);
        if (vData) setReviews(vData.reviews || []);

        if (!sRes.ok || !bRes.ok || !cRes.ok || !rRes.ok || !dRes.ok || !pRes.ok || !vRes.ok) {
          setFetchError('Some data could not be loaded — check the browser console.');
        }
      } catch (err) {
        if (!cancelled) setFetchError('Could not reach the API. Check your connection and try again.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    loadAll();
    return () => { cancelled = true; };
  }, []);

  // Promote/demote a consultant. Throws on failure so ConsultantsView can
  // surface an inline error; resolves with no value on success and the
  // returned record replaces the row in local state.
  async function updateConsultantTier(consultantId, consultantTier) {
    const session = await getCurrentSession();
    if (!session?.idToken) throw new Error('Session expired — please sign in again.');

    const res = await fetch(
      `${API}/admin/consultants/${encodeURIComponent(consultantId)}/tier`,
      {
        method:  'PATCH',
        headers: {
          Authorization:  `Bearer ${session.idToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ consultantTier }),
      }
    );

    if (!res.ok) {
      let detail = 'Update failed';
      try { const j = await res.json(); if (j?.error) detail = j.error; } catch {}
      throw new Error(detail);
    }

    const { consultant } = await res.json();
    setConsultants(prev => prev.map(c => c.id === consultantId ? { ...c, ...consultant } : c));
  }

  async function adminFetch(path, { method = 'GET', body } = {}) {
    const session = await getCurrentSession();
    if (!session?.idToken) throw new Error('Session expired — please sign in again.');
    const res = await fetch(`${API}${path}`, {
      method,
      headers: {
        Authorization:  `Bearer ${session.idToken}`,
        ...(body ? { 'Content-Type': 'application/json' } : {}),
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });
    if (!res.ok) {
      let detail = `${method} ${path} failed`;
      try { const j = await res.json(); if (j?.error) detail = j.error; } catch {}
      throw new Error(detail);
    }
    // 200 with empty body still returns JSON in our handlers, but guard anyway.
    try { return await res.json(); } catch { return {}; }
  }

  async function createConsultant({ name, stratosEmail, personalEmail }) {
    const { consultant } = await adminFetch('/admin/consultants', {
      method: 'POST',
      body:   { name, stratosEmail, personalEmail },
    });
    setConsultants(prev => [...prev, consultant]);
  }

  async function updateConsultantStatus(consultantId, status) {
    const { consultant } = await adminFetch(
      `/admin/consultants/${encodeURIComponent(consultantId)}/status`,
      { method: 'PATCH', body: { status } },
    );
    setConsultants(prev => prev.map(c => c.id === consultantId ? { ...c, ...consultant } : c));
  }

  async function removeConsultant(consultantId) {
    await adminFetch(
      `/admin/consultants/${encodeURIComponent(consultantId)}`,
      { method: 'DELETE' },
    );
    setConsultants(prev => prev.filter(c => c.id !== consultantId));
  }

  async function refundBooking(bookingId) {
    await adminFetch(
      `/admin/bookings/${encodeURIComponent(bookingId)}/refund`,
      { method: 'POST' },
    );
    setBookings(prev => prev.map(b => b.id === bookingId ? { ...b, status: 'refunded' } : b));
  }

  async function createDiscount(payload) {
    const { code } = await adminFetch('/admin/discounts', { method: 'POST', body: payload });
    setDiscounts(prev => ({ ...prev, codes: [...prev.codes, code].sort((a, b) => a.code.localeCompare(b.code)) }));
  }

  async function updateDiscount(codeId, body) {
    const { code } = await adminFetch(
      `/admin/discounts/${encodeURIComponent(codeId)}`,
      { method: 'PATCH', body },
    );
    setDiscounts(prev => ({
      ...prev,
      codes: prev.codes.map(c => c.code === codeId ? { ...c, ...code } : c),
    }));
  }

  async function deleteDiscount(codeId) {
    await adminFetch(`/admin/discounts/${encodeURIComponent(codeId)}`, { method: 'DELETE' });
    setDiscounts(prev => ({ ...prev, codes: prev.codes.filter(c => c.code !== codeId) }));
  }

  async function createPost(payload) {
    const { post } = await adminFetch('/admin/posts', { method: 'POST', body: payload });
    setPosts(prev => [post, ...prev]);
  }

  async function updatePost(slug, body) {
    const { post } = await adminFetch(`/admin/posts/${encodeURIComponent(slug)}`, { method: 'PATCH', body });
    setPosts(prev => prev.map(p => p.slug === slug ? { ...p, ...post } : p));
  }

  async function deletePost(slug) {
    await adminFetch(`/admin/posts/${encodeURIComponent(slug)}`, { method: 'DELETE' });
    setPosts(prev => prev.filter(p => p.slug !== slug));
  }

  async function updateReview(reviewId, body) {
    const { review } = await adminFetch(`/admin/reviews/${encodeURIComponent(reviewId)}`, { method: 'PATCH', body });
    setReviews(prev => prev.map(r => r.reviewId === reviewId ? { ...r, ...review } : r));
  }

  async function deleteReview(reviewId) {
    await adminFetch(`/admin/reviews/${encodeURIComponent(reviewId)}`, { method: 'DELETE' });
    setReviews(prev => prev.filter(r => r.reviewId !== reviewId));
  }

  const navItems = [
    { id: 'dashboard',   label: 'Dashboard',   icon: <GridIcon /> },
    { id: 'alerts',      label: 'Alerts',       icon: <BellIcon />,  badge: alerts.length },
    { id: 'bookings',    label: 'All Bookings', icon: <ListIcon /> },
    { id: 'consultants', label: 'Consultants',  icon: <UsersIcon /> },
    { id: 'revenue',     label: 'Revenue',      icon: <ChartIcon /> },
    { id: 'discounts',   label: 'Discounts',    icon: <TagIcon /> },
    { id: 'blog',        label: 'Blog',         icon: <BookIcon /> },
    { id: 'reviews',     label: 'Reviews',      icon: <StarIcon />, badge: reviews.filter(r => r.status === 'pending').length },
    { id: 'email',       label: 'Email',        icon: <MailIcon /> },
    { id: 'account',     label: 'Account',      icon: <LockIcon /> },
  ];

  const activeNavLabel = navItems.find(n => n.id === activeView)?.label ?? 'Dashboard';

  return (
    <div className="portal-shell">
      {/* ── Sidebar ── */}
      <aside className="portal-sidebar">
        <div className="sidebar-logo">
          <span className="sidebar-logo-circle">
            <img src="/stratos-logo.png" alt="Stratos" className="sidebar-logo-img" />
          </span>
          <span className="sidebar-logo-text">
            <span style={{ color: 'var(--gold)', fontSize: '0.68rem', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase' }}>Admin Portal</span>
          </span>
        </div>

        <nav className="sidebar-nav" aria-label="Admin portal navigation">
          {navItems.map(item => (
            <button
              key={item.id}
              className={`sidebar-nav-item ${activeView === item.id ? 'active' : ''}`}
              onClick={() => setActiveView(item.id)}
              aria-current={activeView === item.id ? 'page' : undefined}
            >
              <span className="sidebar-nav-icon">{item.icon}</span>
              {item.label}
              {item.badge != null && item.badge > 0 && (
                <span className={`sidebar-badge ${item.id === 'alerts' ? 'sidebar-badge-alert' : ''}`}>
                  {item.badge}
                </span>
              )}
            </button>
          ))}
        </nav>

        <div className="sidebar-user-footer">
          <div className="sidebar-user-row">
            <div className="sidebar-avatar" style={{ background: 'linear-gradient(135deg, #0a1628, #1a6bb5)' }}>
              {user.name.charAt(0)}
            </div>
            <div className="sidebar-user-info">
              <div className="sidebar-user-name">{user.name}</div>
              <div className="sidebar-user-role">{user.role}</div>
            </div>
          </div>
          <button className="sidebar-signout" onClick={user.signOut}><SignOutIcon /> Sign Out</button>
        </div>
      </aside>

      {/* ── Main ── */}
      <div className="portal-main">
        <div className="portal-topbar">
          <span className="portal-topbar-title">{activeNavLabel}</span>
          <div className="portal-topbar-right">
            {alerts.length > 0 && activeView !== 'alerts' && (
              <button
                className="topbar-alert-btn"
                onClick={() => setActiveView('alerts')}
                aria-label="View active S1 alerts"
              >
                <BellIcon />
                {alerts.length} S1 alert{alerts.length !== 1 ? 's' : ''}
              </button>
            )}
          </div>
        </div>

        <div className="portal-body">
          {fetchError && (
            <div className="alert-strip" role="alert" style={{ marginBottom: 16 }}>
              <AlertIcon />
              <span>{fetchError}</span>
              <button className="alert-strip-link" onClick={() => window.location.reload()}>
                <RefreshIcon /> Reload
              </button>
            </div>
          )}

          {loading ? (
            <div className="portal-panel" style={{ padding: '40px 24px', textAlign: 'center', color: 'var(--gray-400)' }}>
              Loading…
            </div>
          ) : (
            <>
              {activeView === 'dashboard'   && <DashboardView   stats={stats} alerts={alerts} todaySessions={todaySessions} onGoToAlerts={() => setActiveView('alerts')} />}
              {activeView === 'alerts'      && <AlertsView      alerts={alerts} />}
              {activeView === 'bookings'    && <BookingsView     bookings={bookings} onRefund={refundBooking} />}
              {activeView === 'consultants' && (
                <ConsultantsView
                  consultants={consultants}
                  onUpdateTier={updateConsultantTier}
                  onCreate={createConsultant}
                  onUpdateStatus={updateConsultantStatus}
                  onRemove={removeConsultant}
                />
              )}
              {activeView === 'revenue'     && <RevenueView      revenue={revenue} />}
              {activeView === 'discounts'   && (
                <DiscountsView
                  discounts={discounts}
                  onCreate={createDiscount}
                  onUpdate={updateDiscount}
                  onDelete={deleteDiscount}
                />
              )}
              {activeView === 'blog'        && (
                <BlogView
                  posts={posts}
                  onCreate={createPost}
                  onUpdate={updatePost}
                  onDelete={deletePost}
                />
              )}
              {activeView === 'reviews'     && (
                <ReviewsView
                  reviews={reviews}
                  onUpdate={updateReview}
                  onDelete={deleteReview}
                />
              )}
              {activeView === 'email'       && <EmailClient />}
              {activeView === 'account'     && <ChangePasswordForm />}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
